<template>
    <div id="tryout">
        <!-- begin breadcrumb -->
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                { text: 'Tryout' },
            ]"
            divider="|"
        ></v-breadcrumbs>
        <!-- end breadcrumb -->
        <!-- begin page-header -->
        <h3 class="header-text font-weight-bold">Tryout</h3>
        <!-- end page-header -->
        <v-card>
            <v-card-title>
                Daftar Tryout
                <v-spacer></v-spacer>
                <v-btn
                    id="tryout_tambah"
                    class="align-center text-body-2 blew white--text mr-2"
                    text
                    @click="createTryout()"
                    ><v-icon small class="pr-2">mdi-plus-circle</v-icon>
                    Tryout
                </v-btn>
                <v-btn
                    class="align-center text-body-2 blew white--text mr-2"
                    text
                    @click="reportTryout()"
                >
                    <v-icon small class="mr-2">mdi-chart-bell-curve</v-icon>
                    Lihat Laporan
                </v-btn>
                <v-btn
                    class="align-center text-body-2 blew white--text mr-2"
                    text
                    @click="ratingTryout()"
                >
                    <v-icon small class="mr-2">mdi-star</v-icon>
                    Rating dan Feedback
                </v-btn>
            </v-card-title>
            <v-divider />
            <!-- begin datatable Tryout -->
            <app-datatable
                :items="tryouts"
                :headers="headers"
                :has-action="false"
                :has-export="true"
                :has-duplicate="true"
                :hasReview="true"
                :has-custom-pagination="true"
                :has-custom-search="true"
                :custom-pagination-current-page="pagination.currentPage"
                :custom-pagination-per-page="pagination.perPage"
                :custom-pagination-total-pages="pagination.totalPages"
                :custom-pagination-sort-mode="pagination.sortMode"
                v-on:selected="selectedRow = $event"
                v-on:dblClicked="editTryout()"
                v-on:exportClicked="exportTryout()"
                v-on:duplicateClicked="duplicateTryout()"
                v-on:changePage="
                    pagination = { ...pagination, currentPage: $event }
                "
                v-on:changeSortMode="
                    pagination = { ...pagination, sortMode: $event }
                "
                v-on:doSearch="
                    search = { query: $event.value, by: $event.key.value }
                "
                v-on:openNewTab="openNewTab($event)"
                v-on:openReview="openReview($event)"
            />
        </v-card>
        <!-- end datatable Tryout -->

        <!-- begin duplicate Tryout modal -->
        <v-dialog
            v-model="showModal"
            transition="dialog-top-transition"
            width="536px"
            persistent
            height="168px"
            @click:outside="
                dialogConfirm.title = 'Yakin ingin membatalkan duplikasi ?';
                dialogConfirm.open = true;
                dialogConfirm.function = 'onDuplicateCancel';
            "
            scrollable
        >
            <v-card>
                <v-card-title width="100%">
                    Detail Duplikat Tryout
                    <v-spacer></v-spacer>
                    <v-btn
                        small
                        icon
                        @click="
                            dialogConfirm.title =
                                'Yakin ingin membatalkan duplikasi ?';
                            dialogConfirm.open = true;
                            dialogConfirm.function = 'onDuplicateCancel';
                        "
                        ><v-icon>mdi-close-circle</v-icon></v-btn
                    >
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="py-4 px-6">
                    <v-list-item two-line class="pa-0">
                        <v-list-item-content class="pa-0">
                            <v-list-item-title class="font-weight-bold pb-2">
                                Judul
                            </v-list-item-title>
                            <v-text-field
                                placeholder="Judul Tryout"
                                :disabled="
                                    !auth.scopes.includes('admin_itembank')
                                "
                                v-model="tryout.name"
                                outlined
                            />
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item two-line class="pa-0">
                        <v-list-item-content class="pa-0">
                            <v-list-item-title class="font-weight-bold pb-2">
                                Deskripsi
                            </v-list-item-title>
                            <v-textarea
                                placeholder="Deskripsi Tryout"
                                :disabled="
                                    !auth.scopes.includes('admin_itembank')
                                "
                                v-model="tryout.description"
                                outlined
                            />
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item two-line class="pa-0">
                        <v-list-item-content class="pa-0">
                            <v-list-item-title class="font-weight-bold pb-2">
                                Jenjang
                            </v-list-item-title>

                            <v-radio-group
                                row
                                :disabled="
                                    !auth.scopes.includes('admin_itembank')
                                "
                                v-model="tryout.level"
                            >
                                <v-radio
                                    label="Umum"
                                    value="UMUM"
                                    class="jenjang-selection"
                                    active-class="act-radio-btn"
                                ></v-radio>
                                <v-radio
                                    label="SMA"
                                    value="SMA"
                                    class="jenjang-selection"
                                    active-class="act-radio-btn"
                                ></v-radio>
                                <v-radio
                                    label="SMP"
                                    value="SMP"
                                    class="jenjang-selection"
                                    active-class="act-radio-btn"
                                ></v-radio>
                                <v-radio
                                    label="SD"
                                    value="SD"
                                    class="jenjang-selection"
                                    active-class="act-radio-btn"
                                ></v-radio>
                            </v-radio-group>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item two-line class="px-0 pt-0 pb-4">
                        <v-list-item-content class="pa-0">
                            <v-list-item-title class="font-weight-bold pb-2">
                                Tipe
                            </v-list-item-title>

                            <v-select
                                placeholder="Pilih Tipe"
                                outlined
                                class="pa-0"
                                :disabled="
                                    !auth.scopes.includes('admin_itembank')
                                "
                                v-model="tryout.tipe"
                                :items="[
                                    { text: 'SBMPTN', value: 'SBMPTN' },
                                    {
                                        text: 'Ujian Nasional (UN)',
                                        value: 'UJIAN_AKHIR_NASIONAL',
                                    },
                                    {
                                        text: 'Ujian Akhir Sekolah (UAS)',
                                        value: 'UJIAN_AKHIR_SEKOLAH',
                                    },
                                    {
                                        text: 'Ujian Sekolah',
                                        value: 'UJIAN_SEKOLAH',
                                    },
                                ]"
                            ></v-select>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                        two-line
                        class="px-0 pt-0 pb-4"
                        v-if="tryout.tipe == 'SBMPTN'"
                    >
                        <v-list-item-content class="pa-0">
                            <v-list-item-title class="font-weight-bold pb-2">
                                Kategori
                            </v-list-item-title>

                            <v-select
                                placeholder="Pilih Kategori"
                                outlined
                                class="pa-0"
                                :disabled="
                                    !auth.scopes.includes('admin_itembank')
                                "
                                v-model="tryout.category"
                                :items="[
                                    { text: 'TPS', value: 'TPS' },
                                    { text: 'SAINTEK', value: 'SAINTEK' },
                                    {
                                        text: 'SOSHUM',
                                        value: 'SOSHUM',
                                    },
                                    {
                                        text: 'LITERASI',
                                        value: 'LITERASI',
                                    },
                                ]"
                            ></v-select>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                        two-line
                        class="px-0 pt-0 pb-4"
                        v-else-if="tryout.tipe == 'UJIAN_AKHIR_NASIONAL'"
                    >
                        <v-list-item-content class="pa-0">
                            <v-list-item-title class="font-weight-bold pb-2">
                                Kategori
                            </v-list-item-title>

                            <v-select
                                placeholder="Pilih Kategori"
                                outlined
                                class="pa-0"
                                :disabled="
                                    !auth.scopes.includes('admin_itembank')
                                "
                                v-model="tryout.category"
                                :items="[
                                    { text: 'SAINTEK', value: 'SAINTEK' },
                                    {
                                        text: 'SOSHUM',
                                        value: 'SOSHUM',
                                    },
                                ]"
                            ></v-select>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item two-line class="px-0 pt-0 pb-4" v-else>
                        <v-list-item-content class="pa-0">
                            <v-list-item-title class="font-weight-bold pb-2">
                                Kategori
                            </v-list-item-title>

                            <v-select
                                placeholder="Pilih Kategori"
                                outlined
                                class="pa-0"
                                :disabled="
                                    !auth.scopes.includes('admin_itembank')
                                "
                                v-model="tryout.category"
                                :items="[{ text: 'OTHER', value: 'OTHER' }]"
                            ></v-select>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item two-line class="pa-0">
                        <v-list-item-content class="pa-0">
                            <v-list-item-title class="font-weight-bold pb-2">
                                Durasi (Menit)
                            </v-list-item-title>
                            <v-text-field
                                :disabled="
                                    !auth.scopes.includes('admin_itembank')
                                "
                                v-model="tryout.durasi"
                                type="number"
                                placeholder="(menit)"
                                suffix="menit"
                                outlined
                            />
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item two-line class="pa-0">
                        <v-list-item-content class="pa-0">
                            <v-list-item-title class="font-weight-bold pb-2">
                                Jenis
                            </v-list-item-title>
                            <v-checkbox
                                label="Instant"
                                :disabled="
                                    !auth.scopes.includes('admin_itembank')
                                "
                                v-model="tryout.is_repeated"
                                class="pa-0 ma-0"
                                outlined
                            />
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item two-line class="py-0 px-1">
                        <v-list-item-content>
                            <v-list-item-title class="font-weight-bold pb-2">
                                Waktu Mulai
                            </v-list-item-title>
                            <v-container>
                                <v-row>
                                    <v-col cols="6">
                                        <v-menu
                                            ref="menu"
                                            v-model="tryout.start_date.option"
                                            :close-on-content-click="false"
                                            transition="slide-y-reverse-transition"
                                            offset-y
                                            min-width="auto"
                                        >
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <v-text-field
                                                    v-model="
                                                        tryout.start_date.value
                                                    "
                                                    append-icon="mdi-calendar"
                                                    placeholder="Tanggal"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    outlined
                                                    :disabled="
                                                        !auth.scopes.includes(
                                                            'admin_itembank',
                                                        )
                                                    "
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-model="
                                                    tryout.start_date.value
                                                "
                                                no-title
                                                scrollable
                                                @change="
                                                    tryout.start_date.option = false
                                                "
                                            >
                                            </v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-menu
                                            ref="menu1"
                                            v-model="tryout.start_time.option"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="slide-y-reverse-transition"
                                            offset-y
                                            max-width="290px"
                                            min-width="290px"
                                        >
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <v-text-field
                                                    v-model="
                                                        tryout.start_time.value
                                                    "
                                                    outlined
                                                    placeholder="Jam"
                                                    append-icon="mdi-clock-time-four-outline"
                                                    readonly
                                                    :disabled="
                                                        !auth.scopes.includes(
                                                            'admin_itembank',
                                                        )
                                                    "
                                                    v-bind="attrs"
                                                    v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-time-picker
                                                v-if="tryout.start_time.option"
                                                v-model="
                                                    tryout.start_time.value
                                                "
                                                format="24hr"
                                                @input="
                                                    tryout.start_time.value =
                                                        tryout.start_time.value
                                                            ? tryout.start_time
                                                                  .value + ':00'
                                                            : null
                                                "
                                                @click:minute="
                                                    $refs.menu1.save(
                                                        tryout.start_time.value,
                                                    )
                                                "
                                            ></v-time-picker>
                                        </v-menu>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item two-line class="py-0 px-1">
                        <v-list-item-content>
                            <v-list-item-title class="font-weight-bold pb-2">
                                Waktu Berakhir
                            </v-list-item-title>
                            <v-container>
                                <v-row>
                                    <v-col cols="6">
                                        <v-menu
                                            ref="menu"
                                            v-model="tryout.end_date.option"
                                            :close-on-content-click="false"
                                            transition="slide-y-reverse-transition"
                                            offset-y
                                            min-width="auto"
                                        >
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <v-text-field
                                                    v-model="
                                                        tryout.end_date.value
                                                    "
                                                    append-icon="mdi-calendar"
                                                    placeholder="Tanggal"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    outlined
                                                    :disabled="
                                                        !auth.scopes.includes(
                                                            'admin_itembank',
                                                        )
                                                    "
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-model="tryout.end_date.value"
                                                no-title
                                                scrollable
                                                @change="
                                                    tryout.end_date.option = false
                                                "
                                            >
                                            </v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-menu
                                            ref="menu"
                                            v-model="tryout.end_time.option"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="slide-y-reverse-transition"
                                            offset-y
                                            max-width="290px"
                                            min-width="290px"
                                        >
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <v-text-field
                                                    v-model="
                                                        tryout.end_time.value
                                                    "
                                                    outlined
                                                    placeholder="Jam"
                                                    append-icon="mdi-clock-time-four-outline"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    :disabled="
                                                        !auth.scopes.includes(
                                                            'admin_itembank',
                                                        )
                                                    "
                                                ></v-text-field>
                                            </template>
                                            <v-time-picker
                                                v-if="tryout.end_time.option"
                                                v-model="tryout.end_time.value"
                                                format="24hr"
                                                @input="
                                                    tryout.end_time.value =
                                                        tryout.end_time.value
                                                            ? tryout.end_time
                                                                  .value + ':00'
                                                            : null
                                                "
                                                @click:minute="
                                                    $refs.menu.save(
                                                        tryout.end_time.value,
                                                    )
                                                "
                                            ></v-time-picker>
                                        </v-menu>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-list-item-content>
                    </v-list-item>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="justify-end">
                    <v-btn
                        text
                        elevation="0"
                        @click="
                            dialogConfirm.title =
                                'Yakin ingin membatalkan duplikasi ?';
                            dialogConfirm.open = true;
                            dialogConfirm.function = 'onDuplicateCancel';
                        "
                        >Batal</v-btn
                    >
                    <v-btn
                        dark
                        color="blew"
                        @click="
                            dialogConfirm.title =
                                'Yakin ingin melakukan duplikasi pada Tryout ini ?';
                            dialogConfirm.open = true;
                            dialogConfirm.function = 'onDuplicateConfirm';
                        "
                        >Simpan</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- end duplicate Tryout modal -->

        <!-- begin confirm modal -->
        <v-dialog v-model="dialogConfirm.open" persistent max-width="506px">
            <v-card>
                <v-card-title
                    class="text-h5"
                    style="word-break: break-word !important"
                >
                    {{ dialogConfirm.title }}
                </v-card-title>
                <v-card-text>
                    {{ dialogConfirm.subtitle }}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="darkFade"
                        text
                        @click="dialogConfirm.open = false"
                    >
                        Batal
                    </v-btn>
                    <v-btn
                        v-if="dialogConfirm.function == 'onDuplicateConfirm'"
                        color="blew"
                        text
                        @click="onDuplicateConfirm"
                    >
                        OK
                    </v-btn>
                    <v-btn
                        v-if="dialogConfirm.function == 'onDuplicateCancel'"
                        color="blew"
                        text
                        @click="onDuplicateCancel"
                    >
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- end confirm modal -->

        <!-- begin preview soal modal -->
        <preview-soal
            v-if="dialogReview"
            :data="data_preview"
            :dialog-review="dialogReview"
            @closeDialog="closeDialogReview()"
        ></preview-soal>
        <!-- end preview soal modal -->

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import { mapState } from "vuex";
import DataTable from "@/modules/global/components/plugins/DataTable-c";
import Moment from "moment";
import Spinner from "@/modules/global/components/plugins/Spinner";
import TryoutService from "@/modules/tryout/services/tryout.js";
import PreviewSoal from "./PreviewSoal.vue";

export default {
    name: "tryout",

    components: {
        "app-datatable": DataTable,
        "app-spinner": Spinner,
        "preview-soal": PreviewSoal,
    },

    data: function () {
        return {
            tryouts: [],
            selectedRow: null,
            search: null,
            isLoading: true,
            tryout: {
                start_date: {
                    option: false,
                    value: null,
                },
                end_date: {
                    option: false,
                    value: null,
                },
                start_time: {
                    option: false,
                    value: null,
                },
                end_time: {
                    option: false,
                    value: null,
                },
            },
            pagination: {
                perPage: 10,
                currentPage: 1,
                totalPages: 0,
                sortMode: "desc",
            },
            headers: [
                { text: "Aksi", value: "actions", width: 80 },
                { text: "Code", value: "code", width: 130 },
                { text: "Nama", value: "name", width: 200 },
                { text: "Jenis", value: "jenis", width: 150 },
                { text: "Jenjang", value: "level", width: 150 },
                { text: "Tipe", value: "type", width: 170 },
                { text: "Subtests", value: "subtests", width: 150 },
                { text: "Jml. Soal", value: "jml_soal", width: 150 },
                { text: "Durasi (Menit)", value: "durasi", width: 150 },
                { text: "Status", value: "status", width: 130 },
                { text: "Created At", value: "created_at", width: 120 },
            ],
            headersKey: [
                "no",
                "code",
                "name",
                "jenis",
                "level",
                "type",
                "subtests",
                "jml_soal",
                "durasi",
                "status",
                "created_at",
            ], // camel case for matching search with API
            dialogConfirm: {
                open: false,
                title: null,
                subtitle: null,
                function: null,
            },
            showModal: false,
            dialogReview: false,
            data_preview: null,
        };
    },

    computed: {
        ...mapState(["auth"]),
    },

    watch: {
        pagination: function () {
            this.fetchData();
        },

        search() {
            this.fetchData();
        },
    },

    mounted: function () {
        this.fetchData();
    },

    methods: {
        // Get all data Tryout
        fetchData: function () {
            var context = this;
            var search = null;
            var pagination = {
                perPage: this.pagination.perPage,
                currentPage: this.pagination.currentPage,
                sortMode: this.pagination.sortMode,
            };

            if (
                this.$store.state.datatable.filter &&
                this.$store.state.datatable.pageBefore == "TryoutForm"
            ) {
                search = {
                    query: this.$store.state.datatable.filter.value,
                    by: this.headersKey[this.$store.state.datatable.filter.key],
                };
            } else {
                search = this.search;
            }

            context.isLoading = true;

            TryoutService.getListTryout(pagination, search, function (result) {
                context.tryouts = [];

                if (result.success) {
                    result.data.tryouts.forEach(function (tryout, index) {
                        var subtests = [];
                        var count = 0;
                        tryout.subtests.forEach(function (subtest) {
                            subtests.push(subtest.subject_name);
                            count += subtest.item_count;
                        });

                        var createdAt = Moment(tryout.created_at).format(
                            "YYYY-MM-DD",
                        );
                        var start_date = tryout.start_date;
                        var start_time = tryout.start_time;
                        var end_date = tryout.end_date;
                        var end_time = tryout.end_time;
                        var jenis = tryout.is_repeated
                            ? "INSTANT"
                            : "BERAGENDA";
                        var row = {
                            id: tryout.id,
                            no: index,
                            code: tryout.code,
                            bundle_code: tryout.bundle_code,
                            name: tryout.name,
                            description: tryout.description,
                            category: tryout.category,
                            jenis: jenis,
                            is_repeated: tryout.is_repeated,
                            level: tryout.level,
                            type: tryout.type,
                            subtests: subtests.join(", "),
                            jml_soal: count,
                            durasi: tryout.duration,
                            status: tryout.status,
                            created_at: createdAt,
                            created_at: createdAt,
                            start_date: { value: start_date, option: false },
                            start_time: { value: start_time, option: false },
                            end_date: { value: end_date, option: false },
                            end_time: { value: end_time, option: false },
                        };

                        context.pagination.totalPages = tryout.page;
                        context.tryouts.push(row);
                    });
                    context.isLoading = false;
                }
                context.isLoading = false;
            });
        },

        // get index data in datatable and redirect page by user id
        editTryout: function () {
            var tryoutId = this.selectedRow.id;
            var context = this;
            TryoutService.getTryoutById(tryoutId, function (result) {
                if (result.success) {
                    context.$store.commit("tryout_init", result.data);
                    context.$router.push({
                        path: "tryout-form",
                        query: { id: context.selectedRow.id },
                    });
                }
            });
        },

        openNewTab: function () {
            let routeData = this.$router.resolve({
                path: "tryout-form",
                query: { id: this.selectedRow.id },
            });

            window.open(routeData.href, "_blank");
        },

        reportTryout() {
            this.$router.push({ path: "/tryout-report" });
        },

        ratingTryout() {
            this.$router.push({ path: "/tryout-rating" });
        },

        // Redirect to Tryout Form
        createTryout: function () {
            if (this.auth.scopes.includes("admin_itembank")) {
                this.$store.commit("tryout_reset");
                this.$router.push({ path: "/tryout-form" });
            } else {
                this.$store.commit("showAlert", {
                    message: `Anda tidak memiliki akses untuk membuat Tryout!`,
                    type: "error",
                });
            }
        },

        // export Tryout that choosen
        exportTryout: function () {
            var tryoutId = this.selectedRow.id;
            TryoutService.getTryoutById(tryoutId, function (result) {
                if (result.success) {
                    delete result.data.id;
                    delete result.data.code;
                    delete result.data.group_id;
                    delete result.data.created_at;
                    delete result.data.updated_at;
                    delete result.data.page;

                    let subt = result.data.subtests;
                    if (subt.length > 0) {
                        for (var i = 0; i < subt.length; i++) {
                            delete subt[i].id;
                            delete subt[i].created_at;
                            delete subt[i].updated_at;
                            if (subt[i].details.length > 0) {
                                var det = subt[i].details;
                                for (var b = 0; b < det.length; b++) {
                                    delete det[b].id;
                                    delete det[b].created_at;
                                    delete det[b].updated_at;
                                }
                            }
                        }
                    }
                    result.data.status = "DRAFT";
                    let data = JSON.stringify([result.data]);
                    let blob = new Blob([data]);
                    let link = document.createElement("a");
                    link.href = window.URL.createObjectURL(blob);
                    link.download =
                        "tryout_export_" + new Date().getTime() + ".json";
                    link.click();
                }
            });
        },

        // get detail data on selectedRow and open duplicate Tryout modal
        duplicateTryout() {
            var tryoutId = this.selectedRow.id;
            this.tryout = this.selectedRow;
            this.tryout.name = "Duplikat " + this.tryout.name;
            var context = this;

            DatepickerPlugin.init(
                "#startDate",
                function (value) {
                    context.tryout.start_date = value;
                },
                "yyyy-mm-dd",
            );

            DatepickerPlugin.init(
                "#endDate",
                function (value) {
                    context.tryout.end_date = value;
                },
                "yyyy-mm-dd",
            );

            ClockpickerPlugin.init(".startTime", function (value) {
                context.tryout.start_time.value = value + ":00";
            });

            ClockpickerPlugin.init(".endTime", function (value) {
                context.tryout.end_time = value + ":00";
            });

            this.showModal = true;
        },

        // confirm to duplicate Tryout
        onDuplicateConfirm() {
            const context = this;
            const datafull = this.tryout;
            context.isLoading = true;

            var tryout = {
                id: datafull.id,
                is_repeated: datafull.is_repeated,
                is_free_access: false,
                category: datafull.category,
                name: datafull.name,
                description: datafull.description,
                level: datafull.level,
                type: datafull.tipe,
                duration: datafull.durasi,
                start_date: datafull.start_date.value,
                end_date: datafull.end_date.value,
                start_time: datafull.start_time.value,
                end_time: datafull.end_time.value,
            };

            TryoutService.duplicateTryout(tryout, (result) => {
                if (result.success) {
                    context.$store.commit("showAlert", {
                        message: `Dupikasi Tryout Berhasil!`,
                        type: "success",
                    });
                    context.isLoading = false;
                    context.showModal = false;
                    context.fetchData();
                    context.tableKey++;
                } else {
                    context.$store.commit("showAlert", {
                        message: `Gagal melakukan aktivasi user!`,
                        submessage: result.message,
                        type: "error",
                    });
                    context.isLoading = true;
                    context.showModal = false;
                    context.fetchData();
                    context.tableKey++;
                }
            });

            this.tryout = {
                start_date: {
                    option: false,
                    value: null,
                },
                end_date: {
                    option: false,
                    value: null,
                },
                start_time: {
                    option: false,
                    value: null,
                },
                end_time: {
                    option: false,
                    value: null,
                },
            };
            this.selectedRow = null;
            this.dialogConfirm.open = false;
            this.showModal = false;
        },

        // confirm to close duplicate Tryout modal
        onDuplicateCancel() {
            this.selectedRow = null;
            this.dialogConfirm.open = false;
            this.showModal = false;
            this.fetchData();
        },

        openReview(data) {
            this.dialogReview = true;
            this.data_preview = data;
        },

        closeDialogReview() {
            this.dialogReview = false;
        },
    },
};
</script>



// WEBPACK FOOTER //
// Tryout.vue?bc4fb4fe